<script>
	let { title, centerTitle = null, content, children } = $props();
</script>

<div class="accordion__item">
	<input type="checkbox" name="accordion" id={title} />
	<label for={title} class:justify-center={centerTitle}>{title}</label>
	<div class="accordion__content">
		{#if content}
			{@render content()}
		{:else}
			<ul>
				{@render children?.()}
			</ul>
		{/if}
	</div>
</div>

<style>
	.accordion__item input:checked ~ .accordion__content {
		max-height: 52em;
		padding: 10px 10px 20px;
	}

	.accordion__item input:checked ~ label::before {
		content: '-';
	}

	.accordion__item > label::before {
		content: '+';
		margin-right: 10px;
		font-size: 24px;
		font-weight: 600;
	}

	.accordion__item > label {
		display: flex;
		align-items: center;
		padding: 10px;
		font-size: 1.1rem;
		font-weight: 500;
		cursor: pointer;
	}

	.accordion__item:has(input:checked) {
		color: white;
		background: var(--color-indow-blue);
		box-shadow:
			4px 4px 10px -1px rgba(0, 0, 0, 0.15),
			-4px -4px 10px -1px rgba(255, 255, 255, 0.7);
	}

	.accordion__item:hover {
		color: white;
		background: var(--color-indow-blue);
		box-shadow:
			4px 4px 10px -1px rgba(0, 0, 0, 0.15),
			-1px -2px 5px -1px rgba(255, 255, 255, 0.7);
	}

	.accordion__item > input {
		display: none;
	}

	.accordion__item {
		list-style: none;
		height: min-content;
		padding: 0.45rem 0.6rem;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		color: var(--color-indow-blue);
	}

	.accordion__content {
		color: inherit;
		padding: 0 10px;
		line-height: 26px;
		max-height: 0;
		overflow: hidden;
		transition: all 0.5s ease;
	}

	.accordion__content > ul {
		display: flex;
		flex-direction: column;
		gap: 0.25em;
		padding-left: 1em;
	}

	.accordion__content > ul :global(li) {
		--listCircleWidth: 5px;
		display: grid;
		grid-auto-flow: column;
		grid-template-columns: var(--listCircleWidth) 1fr;
		column-gap: 0.35rem;
		position: relative;
	}

	.accordion__content > ul :global(a) {
		color: inherit;
		grid-column: 2 / -1;
	}

	.accordion__content > ul :global(a::before) {
		content: '';
		display: block;
		aspect-ratio: 1/1;
		width: var(--listCircleWidth);
		background-color: var(--color-indow-white);
		position: absolute;
		clip-path: circle(45%);
		left: 0;
		top: 0.75em;
	}

	.accordion__content > ul :global(a:hover) {
		color: var(--color-indow-grey-light);
	}
</style>
